import m from 'mithril'
import { loadSession } from './state.ts'
import { Layout } from './views/Layout.ts'
import { ListView } from './views/ListView.ts'
import { ListsView } from './views/ListsView.ts'
import { Login } from './views/Login.ts'
import { ProfileView } from './views/ProfileView.ts'
import { RestaurantView } from './views/RestaurantView.ts'
import { SearchView } from './views/SearchView.ts'
import { SettingsView } from './views/SettingsView.ts'
import { Timeline } from './views/Timeline.ts'
import './styles/index.css'

m.route.prefix = ''

type AnyComponent = m.ComponentTypes<any, any>

const page = (component: AnyComponent): m.RouteResolver => ({
  render: (vnode) => m(Layout, [m(component, { ...vnode.attrs, key: m.route.get() })]),
})

const root = document.getElementById('app')!

loadSession().finally(() => {
  m.route(root, '/', {
    '/': page(Timeline),
    '/search': page(SearchView),
    '/r/:ref': page(RestaurantView),
    '/lists': page(ListsView),
    '/l/:id': page(ListView),
    '/u/:username': page(ProfileView),
    '/settings': page(SettingsView),
    '/login': page(Login),
  })
})
